import WistiaPreloader from './WistiaPreloader';

export default WistiaPreloader;
